import moment from "moment";

export class Roster {
    StaffID;
    DateWork;
    ShiftCode;
    AddBy;
    SysDB;
    constructor() {
        this.StaffID = "";
        this.DateWork = moment().format("YYYY-MM-DD");
        this.ShiftCode = "";
        this.AddBy = "";
        this.SysDB = false
    }
}



// WEBPACK FOOTER //
// ./src/model/Roster.js